import React, { useEffect, useState } from 'react';
import {  message } from 'antd';
//import { InboxOutlined } from '@ant-design/icons';
//import type { UploadProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../styles/global.css';
import regionWiseContentManagementApi from '../services/regionWiseContentManagementApi';
import tripManagementApi from '../services/tripManagementApi';
import PopupComponent from '../utils/PopupComponent';
import Spinner from '../components/custom/Spinner';
import cityApi from '../services/cityApi';
import { 
    CityParams,
    POIParams, 
    TripPOIParams,
    CityExportParams, 
    POIExportParams, 
    TripPOIExportParams 
} from '../services/importExportTypes';
import { importStrategies, ImportOption } from '../services/importHandler';
import { SelectionValueMap,SelectionOption } from '../services/overrideAppendMap';
import importExportApi from '../services/importExportApi';
import { exportXlsxFromResponse } from '../utils/downloadDataUsingBlobHelper';

const ExportPage : React.FC = () => {

  const navigate = useNavigate();
  const [regionItems, setRegionItems] = useState<RegionResponse[]>([]);
  const [tripItems, setTripItems] = useState<TripResponse[]>([]);
  const [cityItems, setCityItems] = useState<CityResponse[]>([]);
  const [selectedRegionId, setSelectedRegionId] = useState<string>('-999');
  const [selectedRegionText, setSelectedRegionText] = useState<string>('');
  const [selectedCityId, setSelectedCityId] = useState<string>('-999');
  const [selectedCityText, setSelectedCityText] = useState<string>('');
  const [isDisabledCity, setIsDisabledCity] = useState<boolean>(true);
  const [selectedDirectionId, setSelectedDirectionId] = useState<string>('-999');
  const [selectedTripId, setSelectedTripId] = useState<string>('-999');
  const [selectedTripText, setSelectedTripText] = useState<string>('');
  const [isDisabledTrip, setIsDisabledTrip] = useState<boolean>(true);


  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const [showPopup, setShowPopup] = useState(false);
  const [isLoadingOptionsRegion, setIsLoadingOptionsRegion] = useState<boolean>(true);
  const [isLoadingOptionsCity, setIsLoadingOptionsCity] = useState<boolean>(false);
  const [isLoadingOptionsTrip, setIsLoadingOptionsTrip] = useState<boolean>(false);

  const [showTripPOIDiv, setShowTripPOIDiv] = useState(false);
  const [showRegionTags, setRegionTags] = useState(true);
  const [showCityTags, setCityTags] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const [errorMessageRegion, setErrorMessageRegion] = useState<string>('');
  const [errorMessageCity, setErrorMessageCity] = useState<string>('');
  const [errorMessageDirection, setErrorMessageDirection] = useState<string>('');
  const [errorMessageTrip, setErrorMessageTrip] = useState<string>('');
  
  const [showDownloadOptions, setShowDownloadOptions] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDisabledDownloadCSV, setIsDisabledDownloadCSV] = useState(true);
  
  const handleBackClick = async () => {
    navigate('/data-imp-exp-home');
  };

  const [selectedGroupButton, setSelectedGroupButton] = useState<string>('city');

   useEffect(() => {
    const fetchRegion = async () => {
      try {
        setIsLoadingOptionsRegion(true);
        const regionsResponse = await regionWiseContentManagementApi.getRegionWiseContentManagement();
        if (Array.isArray(regionsResponse.data)) {
          setRegionItems(regionsResponse.data);
        }
      } catch (err) {
        console.error('Failed to load region:', err);
      }
      finally {
        setIsLoadingOptionsRegion(false);
      }
    };

    fetchRegion();
  }, []);

  const handleRegionChangeAction = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const selectedText = e.target.options[e.target.selectedIndex].text;

    setSelectedRegionId(value);
    setSelectedRegionText(selectedText);

    if (value === '-999') {
      setSelectedCityId(value);
      setIsDisabledCity(true);
      setIsDisabledDownloadCSV(true);
      return;
    }
    else
      setErrorMessageRegion('');
    if (selectedGroupButton == 'POI') {
      try {
        setIsLoadingOptionsCity(true);
        const city = await cityApi.getCitiesByRegionId(value);
        if (Array.isArray(city.cityDataResponses)) {
          setCityItems(city.cityDataResponses);
        }
        setIsDisabledCity(false);
      }
      catch (error) {
        console.error('Failed to fetch city:', error);
      } finally {
        setIsLoadingOptionsCity(false);
      }
    }
    else {
      setIsDisabledDownloadCSV(false);
    }
  };

  const handleCityChangeAction = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const selectedText = e.target.options[e.target.selectedIndex].text;
    setSelectedCityId(value);
    setSelectedCityText(selectedText);

    if(value != '-999'){
      setErrorMessageCity('');
      setIsDisabledDownloadCSV(false);
    }
    else{
      setIsDisabledDownloadCSV(true);
    }

  };

  const directionChangeAction = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const directionValue = e.target.value;
    setSelectedDirectionId(directionValue);

     if(directionValue === '-999'){
      setSelectedTripId(directionValue);
      setIsDisabledTrip(true);
      return;    
    }
    else
      setErrorMessageDirection('');

    try {
      setIsLoadingOptionsTrip(true);
      const trip = await tripManagementApi.getTripManagementByDirectionId(directionValue);

      if (Array.isArray(trip)) {
        setTripItems(trip);
      }
      setIsDisabledTrip(false);
    } catch (error) {
      console.error('Failed to fetch trip:', error);
    } finally {
      setIsLoadingOptionsTrip(false);
    }
  };

  const handleTripChangeAction = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const selectedText = e.target.options[e.target.selectedIndex].text;

    setSelectedTripId(value);
    setSelectedTripText(selectedText);
    if(value != '-999'){
        setErrorMessageTrip('');
        setIsDisabledDownloadCSV(false);
    }
    else{
      setIsDisabledDownloadCSV(true);
    }
  };
  
  const dataExportValidation = () => {
      let validationFlag: boolean;
      validationFlag = true;

      switch (selectedGroupButton) {
      case 'city':
        if(selectedRegionId == "-999")
          {
            validationFlag = false;
            setErrorMessageRegion('Please select a region');
          }
        break;
      case 'POI':
        if(selectedRegionId == "-999"){
          validationFlag = false;
          setErrorMessageRegion('Please select a region');
        }
        if(selectedCityId == "-999"){
          validationFlag = false;
          setErrorMessageCity('Please select a city');
        }
        break;
      case 'TripPOI':
        if(selectedDirectionId == "-999"){
          validationFlag = false;
          setErrorMessageDirection('Please select a direction');
        }
        if(selectedTripId == "-999"){
          validationFlag = false;
          setErrorMessageTrip('Please select a trip');
        }
        break;
      }
      return validationFlag;
  };

  const importChoiceSelection = (choice:string) => {

    switch (choice) {
      case 'city':
        setShowTripPOIDiv(false);
        setCityTags(false);
        setRegionTags(true);
        break;
      case 'POI':
        setShowTripPOIDiv(false);
        setCityTags(true);
        setRegionTags(true);
        break;
      case 'TripPOI':
        setShowTripPOIDiv(true);
        setCityTags(false);
        setRegionTags(false);
        break;
      }
  };
   
  const handleDataDownloadAction = async () => {
    setIsSubmitting(true);

    try {
      let  downloadedFileName ='';
      switch (selectedGroupButton) {
        case 'city':
          const cityParams: CityExportParams = {
            regionID: selectedRegionId,
            regionName : selectedRegionText,
          };
          const importResponseCity = await importExportApi.exportCity(cityParams);
          downloadedFileName = exportXlsxFromResponse(importResponseCity,selectedGroupButton);
          break;
        case 'POI':
          const poiParams: POIExportParams = {
            cityID: selectedCityId,
            cityName: selectedCityText,
          };
          const importResponsePOI = await importExportApi.exportPOI(poiParams);
          downloadedFileName = exportXlsxFromResponse(importResponsePOI, selectedGroupButton);
          break;

        case 'TripPOI':
          const tripPOIParams: TripPOIExportParams = {
            tripManagementID: selectedTripId,
            tripName: selectedTripText,
          };
         const importResponseTripPOI = await importExportApi.exportTripPOI(tripPOIParams);
         downloadedFileName = exportXlsxFromResponse(importResponseTripPOI, selectedGroupButton);
          break;
        default:
          throw new Error('Unsupported option selected');
      }

      // if (!importResponse.ok) 
      //   throw new Error('API error');
       messageApi.success(`${downloadedFileName} Downloaded successfully`);
      setShowDownloadOptions(false);
    } catch (err) {
      messageApi.error((err as Error).message);
    }
    finally {
        setIsSubmitting(false);
    }
  };

  const handleCity = () => {
    setSelectedGroupButton('city');
    importChoiceSelection('city');
    resetInitialState();
  };

  const handlePOI = () => {
    setSelectedGroupButton('POI');
    importChoiceSelection('POI');
    resetInitialState();
  };

  const handleTripPOI = () => {
    setSelectedGroupButton('TripPOI');
    importChoiceSelection('TripPOI');
     resetInitialState();
  };

  const resetInitialState = () => {
    
    setSelectedRegionId('-999');
    setSelectedCityId('-999');
    setSelectedDirectionId('-999');
    setSelectedTripId('-999');
    setIsDisabledCity(true);
    setIsDisabledTrip(true);
    setIsDisabledDownloadCSV(true);
    setShowDownloadOptions(false);
  }

  return (
    <>
      {contextHolder} {/* ✅ Always rendered at top */}

    <div style={styles.container}>

      {/* Left Side */}
      <div style={styles.leftPanel}>
        
        {/* Back Arrow */}
        <div style={styles.backArrow} onClick={handleBackClick}>
          ← Export
        </div>

        {/* Button Group */}
        <div style={styles.buttonGroup}>
            <button
        style={{
          ...styles.button,
          ...(selectedGroupButton === 'city' ? styles.selected : {}),
        }}
        onClick={handleCity}
      >
        Export City
      </button>
      <button
        style={{
          ...styles.button,
          ...(selectedGroupButton === 'POI' ? styles.selected : {}),
        }}
        onClick={handlePOI}
      >
        Export POI
      </button>
      <button
        style={{
          ...styles.button,
          ...(selectedGroupButton === 'TripPOI' ? styles.selected : {}),
        }}
        onClick={handleTripPOI}
      >
        Export Trip POI
      </button>
        </div>
        {/* Drop down group */}
        { (showRegionTags || showCityTags)  && (
        <div style={styles.gridGroup}>
        {/* Select Region */}
        <label id="region-label" htmlFor="region-select" 
          style=
          {{
            ...styles.label,
            display: showRegionTags ? 'block' : 'none',
          }}
         >Select Region
                {errorMessageRegion && (
                  <span
                    title={errorMessageRegion}
                    style={{
                      color: 'red',
                      cursor: 'help',
                      fontWeight: 'bold',
                      fontSize: '24px',
                    }}
                  >
                     *
                  </span>
                )}
         </label>
        <label id="city-label" htmlFor="city-select" 
          style=
          {{
            ...styles.label,
            display: showCityTags ? 'block' : 'none',
          }}
        >Select City
          {errorMessageCity && (
                  <span
                    title={errorMessageCity}
                    style={{
                      color: 'red',
                      cursor: 'help',
                      fontWeight: 'bold',
                      fontSize: '24px',
                    }}
                  >
                     *
                  </span>
                )}
        </label>
        </div>
        )}

        {/* Drop down group */}
        { (showRegionTags || showCityTags)  && (
        <div style={styles.gridGroup}>
          <select id="region-select" value={selectedRegionId} onChange={handleRegionChangeAction} 
          style=
          {{
            ...styles.select,
            display: showRegionTags ? 'block' : 'none',
          }}
          >
            {isLoadingOptionsRegion ? (
            <option>Loading...</option>
          ) : (
            <>
          <option value="-999">-- Select a region --</option>
            {regionItems.map((item) => (
              <option key={item.id} value={item.id}>
                {item.sectionName}
              </option>
          ))}
          </>
        )}
        </select>
          <select id="city-select" value={selectedCityId} onChange={handleCityChangeAction} 
          style=
          {{
            ...styles.select,
            display: showCityTags ? 'block' : 'none',
          }}
          disabled={isDisabledCity}>
            {isLoadingOptionsCity ? (
            <option>Loading...</option>
          ) : (
            <>
          <option value="-999">-- Select a city --</option>
            {cityItems.map((item) => (
              <option key={item.id} value={item.id}>
                {item.cityName}
              </option>
          ))}
          </>
          )}
        </select>
        </div>
        )}

         {/* Drop down group */}
         { showTripPOIDiv  && (
        <div style=
          {styles.gridGroup} >
        {/* Select Region //display: showTripPOIDiv ? 'block' : 'none',*/}
        <label htmlFor="direction-select" style={styles.label}>Select Direction
            {errorMessageDirection && (
                  <span
                    title={errorMessageDirection}
                    style={{
                      color: 'red',
                      cursor: 'help',
                      fontWeight: 'bold',
                      fontSize: '24px',
                    }}
                  >
                     *
                  </span>
                )}
        </label>
        <label id="trip-label" htmlFor="trip-select" style={styles.label}>Select Trip
          {errorMessageTrip && (
                  <span
                    title={errorMessageTrip}
                    style={{
                      color: 'red',
                      cursor: 'help',
                      fontWeight: 'bold',
                      fontSize: '24px',
                    }}
                  >
                     *
                  </span>
                )}
        </label>
        </div>
         )}
        {/* Drop down group */}
         { showTripPOIDiv  && (
        <div 
          style={styles.gridGroup}>
          <select id="direction-select" value={selectedDirectionId} onChange={directionChangeAction} style={styles.select}>
          <option value="-999">-- Select a direction --</option>
          <option value="0">Northwest</option>
          <option value="1">Southeast</option>
        </select>
          <select id="trip-select" value={selectedTripId} onChange={handleTripChangeAction} style={styles.select} disabled={isDisabledTrip}>
          {isLoadingOptionsTrip ? (
            <option>Loading...</option> // ✅ shown during loading
          ) : (
            <>
          <option value="">-- Select a trip --</option>
           {
              tripItems.map((item) => (
              <option key={item.id} value={item.id}>
                {item.tripName}
              </option>
          ))}
          </>
          )}
        </select>
        </div>
         )}

        <div style={styles.downloadArea}>
      {showDownloadOptions  ? 
      (
        <div style={styles.downloadAreacontainer}>
          <div style={styles.downloadAreaLabelDiv}>
            You are about to export the {selectedGroupButton} list. Do you want to proceed?
          </div>
            <div style={styles.downloadAreaCSVIconDiv}>
                <img
                  src="../images/Excelcon.png"
                  alt="Excel Icon"
                  style={styles.exportAreaCSVIconImg}
                />
            </div>
          <div style={styles.buttonGroup}>
            <button
            style={styles.cancelButtonForDownload}
            disabled={isSubmitting}
            onClick={(e) => {
              e.stopPropagation();
              setShowDownloadOptions(false);
            }}
          >
              Cancel
          </button>
          <button
            style={{
                ...styles.downloadClickButton,
                backgroundColor: isSubmitting ? '#6a9b9e' : baseGreen,
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                opacity: isSubmitting ? 0.8 : 1,
            }}
            onClick={(e) => {
              e.stopPropagation();
              if(dataExportValidation()){
                  handleDataDownloadAction();
              }
            }}
             disabled={isSubmitting}
            >
            {isSubmitting && <Spinner />}
            {isSubmitting ? 'Downloading...' : 'Download'}
          </button>
          </div>
        </div>
      ) : (
        <>
          <p style={styles.importText}>Click on download to export files</p>
          <button type="button" style={{...styles.downloadButton, marginTop: '25px'}}
            onClick={(e) => { e.stopPropagation(); 
             setShowDownloadOptions(true);
            }}
            disabled={isDisabledDownloadCSV}
          >
            {/* You can insert SVG here if needed */}
            <span>Download Excel</span>
          </button>
        </>
      )}

    </div>
      </div>
    </div>
    </>
  );
};

export default ExportPage;


const baseGreen = '#3E767A';
const hoverGreen = '#5B9492';

const buttonBase = {
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    border: `2px solid ${baseGreen}`,
    color: baseGreen,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    height: '100vh',
    width: '100%',
    boxSizing: 'border-box',
  },
  leftPanel: {
    width: '80%',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    boxSizing: 'border-box',
  },
  backArrow: {
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '32px',
  },
  buttonGroup: {
    display: 'flex',
    gap: '20px',
    padding: '20px',
  },
  button: {
    ...buttonBase,
  },
  downloadButton: {
    ...buttonBase,
    backgroundColor: baseGreen,
    color: '#FFFFFF',
    width: '211px',
    height: '50px',
  },
  cancelButtonForDownload :{
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    border: `2px solid ${baseGreen}`,
    color: baseGreen,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    width: '211px',
    height: '50px',
  },
  importText: {
    margin: 0,
    fontSize: '28px',
    color: '#555',
  },
  uploadbuttonText: {
     display: 'inline-block',
    lineHeight: '1.2',
    fontSize: '16px',
  },
  selected: {
    backgroundColor: baseGreen,
    color: '#FFFFFF',
  },
  labelGroup: {
    display: 'flex',
    flexDirection: 'row', 
    gap: '430px',           
    alignItems: 'center',  
    marginBottom: '8px',  
  },
  uploadLabelGroup: {
    flexDirection: 'row', 
    gap: '430px',           
    alignItems: 'center',  
    marginBottom: '25px',
  },
  label: {
    color: '#3E767A', // final color
    textAlign: 'left',
    fontFamily: '"Merriweather Sans", sans-serif',
    fontWeight: 'bold',
    fontSize: '24px',
    letterSpacing: '0px',
    opacity: 1,
  },
  selectGroup : {
    display: 'flex',
    flexDirection: 'row', // default, optional
    gap: '223px',           // you can adjust spacing here (e.g., 8px, 12px, etc.)
    alignItems: 'center',  // optional: align labels vertically
    marginBottom: '12px',  // optional: spacing below group
  },
  select: {
    width: '54%',
    height: '40px',
    backgroundColor: '#F9F9FA',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.06)', // Converted from #0000000F
    borderRadius: '8px',
    border: '1px solid #ccc',
    padding: '0 12px',
    fontSize: '16px',
    outline: 'none',
  },
  downloadArea: {
    border: '2px dashed #3E767A',
    height: '50%',
    borderRadius: '10px',
    padding: '30px',
    textAlign: 'center' as const,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px', // Adds space between <p> and <button>
  },
  rightPanel: {
    width: '20%',
    backgroundColor: '#f4f4f4',
    padding: '24px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    marginBottom: '16px',
  },
  description: {
    fontSize: '14px',
    color: '#333',
  },
  tripPOILabelGroup: {
    display: 'flex',
    flexDirection: 'row', 
    gap: '430px',           
    alignItems: 'center',  
    marginBottom: '8px',  
  },
  tripPOISelectGroup : {
    display: 'flex',
    flexDirection: 'row', // default, optional
    gap: '223px',           // you can adjust spacing here (e.g., 8px, 12px, etc.)
    alignItems: 'center',  // optional: align labels vertically
    marginBottom: '12px',  // optional: spacing below group
  },
  gridGroup: {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px',
  alignItems: 'center',
  marginBottom: '8px',
},
 downloadAreacontainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // centers all children horizontally
    gap: '16px',
    padding: '24px',
  },
 downloadAreaLabelDiv: {
    fontSize: '28px',
    fontWeight: 500,
    color: '#363636',
    textAlign: 'center',
  },
    downloadAreaCSVIconDiv: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '120px',
        margin: '0 auto',
    },
    downloadClickButton :
	{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '20px',
    border: `2px solid ${baseGreen}`,
    color: '#FFFFFF',
    transition: 'all 0.2s ease-in-out',
    width: '211px',
    height: '50px',
  },
   exportAreaCSVIconImg: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
};

